import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';


const MovieListPage = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('batman');

  useEffect(() => {
    fetchMovies();
  }, [searchTerm]);

  const fetchMovies = async () => {
    const response = await fetch(
      `https://www.omdbapi.com/?s=${searchTerm}&apikey=${process.env.REACT_APP_OMDB_API_KEY}`
    );
    const data = await response.json();
    setMovies(data.Search || []);
  };

  return (
    <div>
      <h1>🎬 Movie Explorer</h1>

      <input
        type="text"
        placeholder="Search movies..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="movie-container">
        {movies.length > 0 ? (
          movies.map((movie) => (
            <div key={movie.imdbID} className="movie-card">
              <img src={movie.Poster} alt={movie.Title} />
              <h4>{movie.Title}</h4>
              <p>{movie.Year}</p>
              <Link to={`/movie/${movie.imdbID}`}>
                <button>View More</button>
              </Link>
            </div>
          ))
        ) : (
          <p>No movies found.</p>
        )}
      </div>
    </div>
  );
};

export default MovieListPage;